import Link from '@salesforce/retail-react-app/app/components/link';
import {Button} from '@salesforce/retail-react-app/app/components/shared/ui';

import {RAW_COMPONENTS as BASE_RAW_COMPONENTS} from '@amblique/base/app/constants/raw-components';

const RAW_COMPONENTS = {
  ...BASE_RAW_COMPONENTS,

  'a': [Link, {parse: false}],
  'a[button]': [Button, {as: Link, parse: false}],
};

export {RAW_COMPONENTS};
